export const GET_REPORT_SCHEMA = 'GET_REPORT_SCHEMA';
export const GET_REPORT_SCHEMA_SUCCESS = 'GET_REPORT_SCHEMA_SUCCESS';
export const GET_REPORT_SCHEMA_FAILURE = 'GET_REPORT_SCHEMA_FAILURE';

export const RUN_REPORT = 'RUN_REPORT';
export const RUN_REPORT_SUCCESS = 'RUN_REPORT_SUCCESS';
export const RUN_REPORT_FAILURE = 'RUN_REPORT_FAILURE';
